/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerationJobReprocess } from './GenerationJobReprocess';
export type ApiCreateDocumentGenerationJob = {
  reference_files: Array<number>;
  processing_type?: ApiCreateDocumentGenerationJob.processing_type;
  desired_termination_state?: string | null;
  parser_overrides?: any;
  metadata?: any;
  effort?: ApiCreateDocumentGenerationJob.effort;
  pipeline?: ApiCreateDocumentGenerationJob.pipeline;
  model?: string;
  prompt_set?: string;
  reprocess?: GenerationJobReprocess;
};
export namespace ApiCreateDocumentGenerationJob {
  export enum processing_type {
    CAP_TABLE = 'CAP_TABLE',
    CAP_TABLE_CITATIONS_ONLY = 'CAP_TABLE_CITATIONS_ONLY',
    FINANCIALS = 'FINANCIALS',
    FINANCIAL_MAPPING = 'FINANCIAL_MAPPING',
    PARSING = 'PARSING',
  }
  export enum effort {
    FASTEST = 'fastest',
    STANDARD = 'standard',
    BALANCED = 'balanced',
    HIGH = 'high',
    MAXIMUM = 'maximum',
  }
  export enum pipeline {
    AGENTS_SDK = 'agents_sdk',
    REASONING = 'reasoning',
  }
}

